package uz.ferro.erp.feature.visit.model

import js.date.Date
import kotlinx.serialization.Serializable
import uz.ferro.erp.feature.user.model.UserDto

@Serializable
data class TrackLocationDto(
    val id: Long?,
    val uuid: String?,
    val user: UserDto?,
    val time: Long?,
    val latitude: Double,
    val longitude: Double,
    val speed: Double?,
    val accuracy: Double?,
    val source: String?
)